import LvFanEvent from './LvFanEvent';

const LvFanEventCh = () => {
    return (
        <LvFanEvent
            currentPath="/lv4-ch"
            // songGuideTitle="《Hush》合唱应援指南视频"
            sloganGuideTitle="拍照时间口号指南"
            eventImage="/fan-event-info-ch.png"
        />
    );
};

export default LvFanEventCh;
